import { ApolloLink } from "@apollo/client";
import {
  hasToken,
  isAccessTokenExpired,
  refreshAndForward,
} from "modules/utils/Functions";

const tokenGateLink = new ApolloLink((operation, forward) => {
  if (hasToken() && !isAccessTokenExpired()) {
    return forward(operation);
  }
  return refreshAndForward(operation, forward);
});

export default tokenGateLink;
